module.exports = __webpack_public_path__ + "static/media/svgnav_left.6db72e41.svg";